import {createContext, useContext} from 'react'

interface FieldEditorValidationContextValue {
  setFieldValid: (isValid: boolean) => void
}

// Default: no-op — safe for fields that don't report validation
export const FieldEditorValidationContext = createContext<FieldEditorValidationContextValue>({
  setFieldValid: () => {}
})

export const useFieldEditorValidation = () => useContext(FieldEditorValidationContext)
